import { FormGoal } from 'components/GoalsAndSubgoalsForm/interfaces';
import { SCORECARD_COMMON_GOAL_TYPE_CUSAT } from 'constants/scorecards';
import { ScorecardGoal, TemplateGoal } from 'store/interfaces';

export const isCuSatGoal = (goal: FormGoal | TemplateGoal | ScorecardGoal) =>
  goal.type === SCORECARD_COMMON_GOAL_TYPE_CUSAT;
